import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { IGlobalState } from '../../model/IGlobalState';
import EditAnnouncementComments from './EditAnnouncementComments';
import * as Roles from '../../model/Roles';
import useAsyncEffect from 'use-async-effect';
import { loading } from '../../actions/Loading';
import Announcements from '../stock/Announcements';
import { IAnnouncementsMethods } from '../stock/EditAnnouncement';
import { startSetStock } from '../../actions/CurrentStock';
import Tabs from '../Tabs';
import AnimatedSaveButton from '../AnimatedSaveButton';
import ConfirmEx from '../ConfirmEx';
import { uppercaseFirstLetter } from '../../util/util';
import Config, { IConfigMethods } from '../stock/Config';
import EmailMarketingPage, { IEmailMarketingPageMethods } from '../stock/EmailMarketingPage';
import ReportConfig from '../reportConfig/ReportConfig';

interface IProps{
    match: { params: {  combinedTicker:string, tab?:string, subtab?:string }};
}

const ConfigTabName:string = 'Config';
const CommentsTabName:string = 'Comments';
const AnnouncementsTabName:string = 'Announcements';
const EmailMarketingTabName:string = 'Email Marketing';
const ReportsTabName:string = 'Reports';

const Wrapper = styled.div`

`;

const ClientStockItem: React.FC<IProps> = (props:IProps) => {
    const dispatch = useDispatch();
    const ticker = props.match.params.combinedTicker
    const subTab = props.match.params.subtab;
    const user = useSelector((state: IGlobalState) => state.user)
    const stock = useSelector((state: IGlobalState) => state.currentStock)
    const [ activeTab, setActiveTab ] = useState(uppercaseFirstLetter(props.match.params.tab) || '');
    const emailMarketingPage = React.createRef<IEmailMarketingPageMethods>();
    const configPage = React.createRef<IConfigMethods>();

    useAsyncEffect(async (isMounted:()=>boolean)=> {
        dispatch(loading(true));
        dispatch(startSetStock(ticker))
        dispatch(loading(false));
      }, []);

      const hasRole = (r:string) => stock && user.stockRoles[stock.id].includes(r)

      useAsyncEffect(async (isMounted:()=>boolean)=> {
        // if(user && stock && !activeTab){

        //     let tabDefault = ConfigTabName;
        //     if(user.stockRoles[stock.id].length===1 && hasRole(Roles.CreateCampaign)){
        //         tabDefault = EmailMarketingTabName;
        //     }
        //     setActiveTab(tabDefault)
        // }
        
      }, [ user, stock ]);

      const announcementsPage = React.createRef<IAnnouncementsMethods>();
      const onSavedAnnouncement = async () => { 
            dispatch(startSetStock(ticker))
        }

    const save = async ()=>{
        let success:boolean = false;
        if(activeTab === AnnouncementsTabName){
            success = await announcementsPage.current!.save();
        }else if(activeTab === EmailMarketingTabName){
            success = await emailMarketingPage.current!.save();
        }else if(activeTab === ConfigTabName){
            success = await configPage.current!.save();
        }
        return Promise.resolve(success);
    }

    // Warn before leaving a tab that has unsaved edits. Each editable tab reports
    // dirtiness by deep-comparing its current data against the baseline loaded on
    // mount (and refreshed on save), so reverting a field to its original value
    // does not trigger the prompt. Comments/Reports have no ref and never warn.
    const isCurrentTabDirty = () : boolean => {
        const activeRef =
            activeTab === ConfigTabName ? configPage :
            activeTab === AnnouncementsTabName ? announcementsPage :
            activeTab === EmailMarketingTabName ? emailMarketingPage : null;
        return !!activeRef?.current?.isDirty?.();
    }

    const handleTabChange = async (newTab:string) => {
        if(newTab === activeTab) return;
        if(isCurrentTabDirty()){
            const ok = await ConfirmEx('You have unsaved changes. Discard them and switch tabs?');
            if(!ok) return;
        }
        setActiveTab(newTab);

        // Persist the section tab as /client-stocks/:ticker/:tab so a refresh or
        // the back button restores it.
        const tokens = window.location.pathname.split('/');
        const sectionChanged = decodeURIComponent(tokens[3] || '') !== newTab;

        if(sectionChanged){
            // Moving to a different section: set the section tab and drop any stale
            // sub-tab segment left over from the previous section.
            const base = tokens.slice(0, 3);
            base.push(newTab);
            window.history.replaceState({}, document.title, base.join('/'));
        }else{
            // Same section (e.g. initial load / re-select): keep the sub-tab segment.
            tokens[3] = newTab;
            window.history.replaceState({}, document.title, tokens.join('/'));
        }
    }

    const showConfig = hasRole(Roles.ViewConfig);
    const showAnnouncements = hasRole(Roles.EditAnnouncements);
    const showEmailMarketing = hasRole(Roles.EditMailchimp) || hasRole(Roles.CreateCampaign) || hasRole(Roles.TestSendAnnouncement) || hasRole(Roles.SendMailchimp)
    const showComments = hasRole(Roles.ReplyToComment);
    const showReports = hasRole(Roles.RunReports);

    return <Wrapper>
    { stock && <div>

        <div className="space-between">
                <div className="space-between">
                <h1> { ticker } </h1>
                
                </div>
                
                { activeTab !== ReportsTabName && <AnimatedSaveButton onClick={save}  />} 
            </div>
        { user.stockRoles[stock.id].length === 0 && <p>You do not have any permissions assigned for this Stock. Please contact Investi support</p>}
        
        <Tabs onTabChanged={handleTabChange} activeTab={activeTab}>
    
        
        { showConfig  && <div data-label={ConfigTabName}>
                        <Config    
                        key={stock.id}                    
                        id={stock.id}                    
                        ticker={stock.ticker} 
                        exchange={stock.exchange}
                        
                            ref={configPage}    
                        />
                    </div>}

    { showAnnouncements && <div data-label={AnnouncementsTabName}>
                        <Announcements
                            syncInProgress={false}
                            ref={announcementsPage}
                            onSavedAnnouncement={onSavedAnnouncement}
                        />
                    </div>}

                    {showEmailMarketing && <div data-label={EmailMarketingTabName}>
                        <EmailMarketingPage
                        ref={emailMarketingPage}
                        tab={subTab}
                        />
                    </div>}


                    { showComments && <div data-label={CommentsTabName}>
                         <EditAnnouncementComments combinedTicker={ticker}

                         />
                        </div>}

                    { showReports && <div data-label={ReportsTabName}>
                         <ReportConfig ticker={ticker}
                         
                         />
                        </div>}

                        

        </Tabs>
    </div>
    
    
    }
    




</Wrapper>
}

export default ClientStockItem

